// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e36a7fe","453":"c3db55c9","455":"c12310ad"}[chunkId] + ".chunk.js";
};